export default class UnexpectedStockOutflow {
  constructor({
    id,
    idProducto,
    estatus,
    fecha,
    identificador,
    pedimentoAduana,
    piezas,
    unitario,
    importe,
    motivoSalida,
    detalleSalida,
    observaciones,
    adjuntos,
    producto,
  }) {
    this.id = id
    this.idProducto = idProducto
    this.estatus = estatus
    this.fecha = fecha
    this.identificador = identificador
    this.pedimentoAduana = pedimentoAduana
    this.piezas = piezas
    this.unitario = unitario
    this.importe = importe
    this.motivoSalida = motivoSalida
    this.detalleSalida = detalleSalida
    this.observaciones = observaciones
    this.adjuntos = adjuntos
    this.producto = producto
  }

  static fromPrimitives(primitives) {
    return new UnexpectedStockOutflow(primitives)
  }

  toPrimitives() {
    return {
      idProducto: this.idProducto,
      estatus: this.estatus,
      fecha: this.fecha,
      identificador: this.identificador,
      pedimentoAduana: this.pedimentoAduana,
      piezas: this.piezas,
      unitario: this.unitario,
      importe: this.importe,
      motivoSalida: this.motivoSalida,
      detalleSalida: this.detalleSalida,
      observaciones: this.observaciones,
      adjuntos: this.adjuntos,
      id: this.id,
      producto: this.producto,
    }
  }
} 